import React from "react";
import AddOutReach from "../../components/Pages/Outreach/Add/Add";

const OutReachAdd = () => {
  return (
    <div>
      <AddOutReach />
    </div>
  );
};

export default OutReachAdd;
